import { useTranslation } from "react-i18next";

const Footer = () => {
  const { t } = useTranslation();
  const currentYear = new Date().getFullYear();

  return (
    <footer className="relative text-white py-16 overflow-hidden">
      <div className="max-w-7xl mx-auto px-8 relative z-10">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-12 mb-8">
          <div>
            <h3 className="text-3xl font-bold mb-4 bg-clip-text text-transparent bg-gradient-to-r from-purple-400 to-blue-400">
              🧠 NeuroCell
            </h3>
            <p className="text-gray-400 leading-relaxed">
              {t("footer.description")}
            </p>
          </div>

          <div>
            <h4 className="text-xl font-bold mb-4">{t("footer.contacts")}</h4>
            <p className="text-gray-400 mb-2 hover:text-purple-400 transition-colors cursor-pointer">
              📧 info@neurocell.com
            </p>
            <p className="text-gray-400 hover:text-purple-400 transition-colors cursor-pointer">
              📞 +1 (415) 555-0123
            </p>
          </div>

          <div>
            <h4 className="text-xl font-bold mb-4">{t("footer.social")}</h4>
            <div className="flex gap-4">
              <a
                href="#"
                aria-label="Facebook"
                className="w-12 h-12 bg-gradient-to-br from-purple-600 to-blue-600 rounded-full flex items-center justify-center hover:scale-110 hover:rotate-12 transition-all duration-300 shadow-lg hover:shadow-purple-500/50"
              >
                <span className="text-sm font-bold">f</span>
              </a>
              <a
                href="#"
                aria-label="Twitter"
                className="w-12 h-12 bg-gradient-to-br from-purple-600 to-blue-600 rounded-full flex items-center justify-center hover:scale-110 hover:rotate-12 transition-all duration-300 shadow-lg hover:shadow-purple-500/50"
              >
                <span className="text-sm font-bold">𝕏</span>
              </a>
              <a
                href="#"
                aria-label="LinkedIn"
                className="w-12 h-12 bg-gradient-to-br from-purple-600 to-blue-600 rounded-full flex items-center justify-center hover:scale-110 hover:rotate-12 transition-all duration-300 shadow-lg hover:shadow-purple-500/50"
              >
                <span className="text-sm font-bold">in</span>
              </a>
            </div>
          </div>
        </div>

        <div className="border-t border-gray-800 pt-8 text-center">
          <p className="text-gray-500">
            &copy; {currentYear} NeuroCell. {t("footer.rights")}
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
